import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb077f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"background":"#fff","border-radius":"4px"},
  class: "basics"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleBox" }, "基础信息", -1))
const _hoisted_3 = {
  key: 0,
  class: "centerBox"
}
const _hoisted_4 = { class: "leftBox" }
const _hoisted_5 = { class: "positionBox" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"nowrap"}
}
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconBox",
  style: {"color":"#fccc69"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-Table-renzheng-rengongzhineng",
    style: {"margin-right":"2px","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "AI认证")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconBox",
  style: {"color":"#fccc69"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-Table-renzheng-rengong",
    style: {"margin-right":"2px","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "人工认证")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconBox",
  style: {"color":"#fccc69"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-Table-renzheng-shidi",
    style: {"margin-right":"2px","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "实地认证")
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "positionBox" }
const _hoisted_17 = { style: {"border":"1px solid #d9d9d9","border-radius":"4px","padding":"2px","height":"610px","margin-left":"20px","width":"800px"} }
const _hoisted_18 = {
  key: 1,
  class: "centerBox"
}
const _hoisted_19 = { class: "leftBox" }
const _hoisted_20 = { class: "positionBox" }
const _hoisted_21 = { class: "textarea" }
const _hoisted_22 = { class: "textarea" }
const _hoisted_23 = { class: "textarea" }
const _hoisted_24 = { class: "textarea" }
const _hoisted_25 = { class: "textarea" }
const _hoisted_26 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"nowrap"}
}
const _hoisted_27 = ["title"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconBox",
  style: {"color":"#fccc69"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-Table-renzheng-rengongzhineng",
    style: {"margin-right":"2px","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "AI认证")
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["title"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconBox",
  style: {"color":"#fccc69"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-Table-renzheng-rengong",
    style: {"margin-right":"2px","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "人工认证")
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["title"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconBox",
  style: {"color":"#fccc69"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-Table-renzheng-shidi",
    style: {"margin-right":"2px","font-size":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "实地认证")
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "textarea" }
const _hoisted_37 = { class: "textarea" }
const _hoisted_38 = { class: "textarea" }
const _hoisted_39 = { style: {"border":"1px solid #d9d9d9","border-radius":"4px","padding":"2px","height":"610px","margin-left":"20px","width":"800px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Form_item = _resolveComponent("Form-item")!
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_TerminalCategoryCascader = _resolveComponent("TerminalCategoryCascader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Cascader = _resolveComponent("Cascader")!
  const _component_Baidu_map = _resolveComponent("Baidu-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Form_item, {
                label: "终端名称",
                name: "terminalName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.terminalName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datalist.terminalName) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_Popover, null, {
                content: _withCtx(() => [
                  _createTextVNode(" 建议门店主名+分店名称 如：沃尔玛大连金马路店 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_QuestionCircleOutlined, {
                    class: "icon",
                    title: ""
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_Form_item, {
              label: "终端编码",
              name: "terminalCode"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.datalist.storeShortId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "渠道",
              name: "terminalCategory"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TerminalCategoryCascader, {
                  formState: _ctx.datalist,
                  class: "cascader inputFixed"
                }, null, 8, ["formState"])
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "子渠道",
              name: "childChannel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  placeholder: "请选择",
                  class: "inputFixed",
                  value: _ctx.datalist.childChannel,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.datalist.childChannel) = $event)),
                  "show-search": "",
                  options: _ctx.optionsSubChannel,
                  optionFilterProp: "label",
                  allowClear: "",
                  onSearch: _ctx.searchSubChannel,
                  onChange: _ctx.changeSubChannel
                }, null, 8, ["value", "options", "onSearch", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "规模类型",
              name: "scaleType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  value: _ctx.datalist.scaleType,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.datalist.scaleType) = $event)),
                  class: "inputFixed",
                  placeholder: "请选择",
                  allowClear: "",
                  disabled: 
              _ctx.datalist.childChannel == '' || _ctx.datalist.childChannel == null
            
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Option, { value: "连锁" }, {
                      default: _withCtx(() => [
                        _createTextVNode("连锁")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Option, { value: "独立" }, {
                      default: _withCtx(() => [
                        _createTextVNode("独立")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "认证方式"
            }, {
              default: _withCtx(() => [
                (_ctx.datalist.terminalUnifyTypeCO)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_ctx.datalist.terminalUnifyTypeCO.aiFlag)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "renzhengBox",
                            title: 
                _ctx.datalist.terminalUnifyTypeCO.aiFlag
                  ? 'AI认证' + _ctx.datalist.terminalUnifyTypeCO.aiFlagDate
                  : ''
              
                          }, _hoisted_9, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      (_ctx.datalist.terminalUnifyTypeCO.manualFlag)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "renzhengBox",
                            title: 
                _ctx.datalist.terminalUnifyTypeCO.manualFlag
                  ? '人工认证' + _ctx.datalist.terminalUnifyTypeCO.manualFlagDate
                  : ''
              
                          }, _hoisted_12, 8, _hoisted_10))
                        : _createCommentVNode("", true),
                      (_ctx.datalist.terminalUnifyTypeCO.siteFlag)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            title: 
                _ctx.datalist.terminalUnifyTypeCO.siteFlag
                  ? '实地认证' + _ctx.datalist.terminalUnifyTypeCO.siteFlagDate
                  : ''
              
                          }, _hoisted_15, 8, _hoisted_13))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "省市区",
              name: "province"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Cascader, {
                  value: _ctx.datalist.province,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.datalist.province) = $event)),
                  options: _ctx.options,
                  "show-search": true,
                  placeholder: "请选择",
                  "change-on-select": "",
                  onBlur: _ctx.blurRegionValue,
                  class: "cascader inputFixed",
                  onChange: _ctx.changeCascader
                }, null, 8, ["value", "options", "onBlur", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "乡镇",
              name: "town"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  class: "inputFixed",
                  value: _ctx.datalist.town,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.datalist.town) = $event)),
                  options: _ctx.townOptions,
                  placeholder: "请选择或手动输入",
                  onClick: _ctx.blurRegionValue,
                  allowClear: "",
                  "show-search": ""
                }, null, 8, ["value", "options", "onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "终端地址",
              name: "address"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.datalist.address) = $event)),
                  class: "textarea",
                  maxlength: "200",
                  placeholder: "XX市XX区|县XX街道|村XX路|栋XX号XX大厦|花园（楼盘）XX栋XX楼XX室 如：大连市沙河口区河川街53号建龙苑小区1号楼101室"
                }, "\n          ", 512), [
                  [_vModelText, _ctx.datalist.address]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Form_item, {
                class: "formItem",
                label: "经纬度",
                name: "baidu"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.baidu,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.datalist.baidu) = $event)),
                    placeholder: "请输入",
                    class: "baidulonlat"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_Popover, null, {
                content: _withCtx(() => [
                  _createTextVNode(" 经度 , 纬度 例如：121.241908 , 30.835494 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_QuestionCircleOutlined, {
                    class: "icon",
                    title: ""
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Baidu_map, {
              baidu: _ctx.datalist.baidu || '116.403967,39.915109',
              onChangeBaidu: _ctx.changeBaidu,
              isEdit: true
            }, null, 8, ["baidu", "onChangeBaidu"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_Form_item, { label: "终端名称" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.datalist.terminalName), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_Form_item, { label: "终端编码" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.datalist.storeShortId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "渠道"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.datalist.terminalCategory
                ? _ctx.datalist.terminalCategory.join("/")
                : ""), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "子渠道"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.datalist.childChannel), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "规模类型"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.datalist.scaleType), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "认证方式"
            }, {
              default: _withCtx(() => [
                (_ctx.datalist.terminalUnifyTypeCO)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_ctx.datalist.terminalUnifyTypeCO.aiFlag)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "renzhengBox",
                            title: 
                _ctx.datalist.terminalUnifyTypeCO.aiFlag
                  ? 'AI认证' + _ctx.datalist.terminalUnifyTypeCO.aiFlagDate
                  : ''
              
                          }, _hoisted_29, 8, _hoisted_27))
                        : _createCommentVNode("", true),
                      (_ctx.datalist.terminalUnifyTypeCO.manualFlag)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "renzhengBox",
                            title: 
                _ctx.datalist.terminalUnifyTypeCO.manualFlag
                  ? '人工认证' + _ctx.datalist.terminalUnifyTypeCO.manualFlagDate
                  : ''
              
                          }, _hoisted_32, 8, _hoisted_30))
                        : _createCommentVNode("", true),
                      (_ctx.datalist.terminalUnifyTypeCO.siteFlag)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            title: 
                _ctx.datalist.terminalUnifyTypeCO.siteFlag
                  ? '实地认证' + _ctx.datalist.terminalUnifyTypeCO.siteFlagDate
                  : ''
              
                          }, _hoisted_35, 8, _hoisted_33))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "省市区"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.datalist.province[0] &&
            _ctx.datalist.province[0] +
              "/" +
              _ctx.datalist.province[1] +
              "/" +
              _ctx.datalist.province[2]), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "乡镇"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.datalist.town), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "终端地址"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.datalist.address), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "经纬度",
              name: "baidu",
              style: {"margin-bottom":"129px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.datalist.baidu), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_Baidu_map, {
              baidu: _ctx.datalist.baidu || '116.403967,39.915109',
              isEdit: false,
              onChangeBaidu: _ctx.changeBaidu
            }, null, 8, ["baidu", "onChangeBaidu"])
          ])
        ]))
  ]))
}